import React from 'react';
import BubbleButton from './BubbleButton';
import { Colors } from '../../theme/Colors';
import { ButtonProps } from 'models';
import CircularProgress from '@material-ui/core/CircularProgress';

const defaultStyle = {
    text: {
        color: 'white',
        paddingTop: 3,
        paddingBottom: 3,
    },
    button: {
        outline: 'none',
    },
};

const enabledStyle = {
    button: {
        backgroundColor: Colors.darkNavy,
        '&:hover': {
            backgroundColor: Colors.pressedNavy,
        },
    },
};

const disabledStyle = {
    button: {
        backgroundColor: Colors.disabledGrey,
    },
};

export default function PrimaryButton({
    children,
    leftAlign,
    boldText = true,
    loading = false,
    ...props
}: ButtonProps) {
    function getButton() {
        return (
            <BubbleButton
                defaultStyle={defaultStyle}
                enabledStyle={enabledStyle}
                disabledStyle={disabledStyle}
                boldText={boldText}
                buttonStyle={{ width: leftAlign ? undefined : '100%', minWidth: 180 }}
                {...props}
            >
                {loading ? (
                    <CircularProgress style={{ color: 'white', display: 'flex' }} size={20} thickness={5} />
                ) : (
                    children
                )}
            </BubbleButton>
        );
    }
    return leftAlign ? (
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'flex-end' }}>
            {getButton()}
        </div>
    ) : (
        getButton()
    );
}
